import type { ButtonHTMLAttributes } from 'react'
import { cx } from './cx.js'
import styles from './Button.module.css'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger'
  loading?: boolean
}

export function Button({
  variant = 'secondary',
  loading = false,
  disabled,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles['button'], styles[variant])}
      disabled={disabled ?? loading}
      aria-busy={loading}
      {...rest}
    >
      {children}
    </button>
  )
}
